// Base
import '@splidejs/splide/css/core';
import './base/base';

// Components
import './components/header';
import './components/menu';
import './components/form';
import './components/news';
// import './components/accordion';

// Modules
// import './modules/onePageNav';
// import './modules/fslightbox';
// import './modules/slider';
// import './modules/countUp';
import './modules/gsap';
// import './modules/readMore';
// import './modules/elementsBlocker/elementsBlocker';

// Polyfills
import './polyfills/dialog'; // Safari <= 15.3
import { initSlider } from './modules/slider.js';

window.addEventListener('load', function () {
    initSlider();
});
